import pixi.plugins.app.Application;
import pixi.core.graphics.Graphics;
import pixi.core.textures.Texture;
import pixi.core.sprites.Sprite;
import pixi.core.display.Container;
import js.Browser;
import stocking.Scene;
import stocking.SceneManager;
import ld.scenes.MapScene;

import ld.scenes.MenuScene;
import ld.scenes.GameScene;

import pixi.core.Settings;
import pixi.core.Pixi.ScaleModes;


class Main extends Application 
{

	public function new() 
	{
		super();

		autoResize = false;

		width = 1280;
		height = 720;

		backgroundColor = 0x000000;

		antialias = false;
		onUpdate = _animate;
		roundPixels = true;

		Settings.SCALE_MODE = ScaleModes.NEAREST;
		

		var canvas = Browser.document.createCanvasElement();
		Browser.document.body.appendChild(canvas);

		super.start(null, null, canvas);

		var sceneContainer = new Container();
		stage.addChild(sceneContainer);

		SceneManager.instance.transitionToScene( new MenuScene( renderer, stage ) );

		
	}

	function _animate(e:Float) 
	{
		SceneManager.instance.tick(e);
	}

	static function main() 
	{
		new Main();
	}
}